import React from 'react';

class Check extends React.Component {
	render(){
		if(!this.props.stmt)
		{
			return false;
		}
		return (<div>{this.props.children}</div>);
	}
}

export default Check;


// WEBPACK FOOTER //
// ./src/components/Check.js